import React, {Component} from 'react'
import { Route } from "react-router-dom";
import Home from "./pages/home";
import Nepal from "./pages/nepal";
import Cuba from "./pages/cuba";
import Intro from "./pages/intro";
import Stories from "./pages/stories";
import Inspiration from "./pages/inspiration";
import About from "./pages/about";
import Press from "./pages/press";
import Contact from "./pages/contact";
import Notify from "./pages/notify";
import SpeakingOps from "./pages/speakingOps";
import Blog from "./pages/blog";
import Joys from "./pages/joys";
import Books from "./pages/books";
import Grumple from "./pages/grumple";
import FindGrumple from "./pages/findGrumple";
import BlogDetail from "./pages/blogDetail";
import ThankYou from "./pages/thankYou";
import Toolkits from "./pages/toolkits";
import Subscribe from "./pages/subscribe";
import FiveBrainFucks from "./pages/fiveBrainFucks";
import SevenDayChallenge from "./pages/sevenDayChallenge";
import YearlyAudit from "./pages/yearlyAudit";
import GoalSetting from "./pages/goalSetting";
import FindingTime from "./pages/findingTime";
import Header from "./components/header";
import IntroModal from "./components/introModal";
import Footer from "./components/footer";
import ReactGA from 'react-ga';
ReactGA.initialize('UA-28829848-1');

export default class App extends Component {
  constructor() {
      super();
      this.state = {
        updateKey:0
      };
  }
  componentDidMount = async () =>{
    this.setState({
      ready:true
    })
  }

  componentDidUpdate = () =>{
    window.scrollTo(0, 0);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    if(!this.state.ready) return null;
    return(
      <Route
        render={({ location }) => (
          <div className={"full-height full-width"}>
            <Header />
            <IntroModal />
            <Route exact path="/" render={props => (<Home />)} />
            <Route exact path="/observations" render={props => (<Blog />)} />
            <Route exact path="/article" render={props => (<BlogDetail />)} />
            <Route exact path="/joys" render={props => (<Joys />)} />
            <Route exact path="/notify" render={props => (<Notify />)} />
            <Route exact path="/nepal" render={props => (<Nepal />)} />
            <Route exact path="/cuba" render={props => (<Cuba />)} />
            <Route exact path="/press" render={props => (<Press />)} />
            <Route exact path="/intro" render={props => (<Intro />)} />
            <Route exact path="/about" render={props => (<About />)} />
            <Route exact path="/inspiration" render={props => (<Inspiration />)} />
            <Route exact path="/excerpts" render={props => (<Stories />)} />
            <Route exact path="/contact" render={props => (<Contact />)} />
            <Route exact path="/speakingOps" render={props => (<SpeakingOps />)} />
            <Route exact path="/thankyou" render={props => (<ThankYou />)} />
            <Route exact path="/fiveBrainFucks" render={props => (<FiveBrainFucks />)} />
            <Route exact path="/sevenDayChallenge" render={props => (<SevenDayChallenge />)} />
            <Route exact path="/yearlyAudit" render={props => (<YearlyAudit />)} />
            <Route exact path="/goalSetting" render={props => (<GoalSetting />)} />
            <Route exact path="/findingTime" render={props => (<FindingTime />)} />
            <Route exact path="/toolkit" render={props => (<Toolkits />)} />
            <Route exact path="/subscribe" render={props => (<Subscribe />)} />
            <Route exact path="/grumple" render={props => (<Grumple />)} />
            <Route exact path="/find-grumple" render={props => (<FindGrumple />)} />
            <Route exact path="/books" render={props => (<Books />)} />
          </div>
        )}
      />
    )
	}
}



// WEBPACK FOOTER //
// ./src/app.js